import { render } from "./ReorganizationDrawer.vue?vue&type=template&id=3375380a&scoped=true"
import script from "./ReorganizationDrawer.vue?vue&type=script&lang=js"
export * from "./ReorganizationDrawer.vue?vue&type=script&lang=js"

import "./ReorganizationDrawer.vue?vue&type=style&index=0&id=3375380a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3375380a"]])

export default __exports__